export default __webpack_public_path__ + "static/media/Calendar.12c411b3.svg";